/**
 * TKP-149 / tasarım s.35 md.1 — organizasyon paneli dashboard'u: görev + onay + teyit özeti (karar 2026-09-27). Saf yardımcılar.
 * Görev grafiği organizasyonun durum kayıtlarından (TKP-119) etiketlenir; uyum kartları backend'in `compliance` listesinden.
 */
import { statusOf } from "@/modules/task/task-settings";

/** Görev durumu grafiği: anahtar → organizasyon kaydının adı ve rengi; bilinmeyen anahtar gri, kendi adıyla. */
export const taskStatusChart = (tasksByStatus, statuses) => {
  const keys = Object.keys(tasksByStatus || {});
  const items = keys.map((key) => ({ key, ...statusOf(statuses || [], key), count: tasksByStatus[key] }));
  return { keys, labels: items.map((i) => i.label), datas: items.map((i) => i.count), colors: items.map((i) => i.color || "#6c757d") };
};

/** Modül kartları: yalnız görünür olanlar; satırlar (etiket, değer, bağlantı). */
export const complianceCards = (compliance, t) =>
  (compliance || [])
    .filter((c) => c && c.visible)
    .map((c) => {
      const product = String(c.product || "").toLowerCase();
      const rows = [];
      if (c.approval.enabled) {
        if (c.approval.approver) rows.push({ key: "pending", label: t("organization.dashboard.pending-approvals"), value: c.approval.pending, link: `/${product}/entities`, warn: c.approval.pending > 0 });
        if (c.approval.myOpen) rows.push({ key: "my-open", label: t("organization.dashboard.my-open-drafts"), value: c.approval.myOpen, link: `/${product}/entities` });
        if (c.approval.mySubmitted) rows.push({ key: "my-submitted", label: t("organization.dashboard.my-submitted"), value: c.approval.mySubmitted, link: `/${product}/entities` });
      } else rows.push({ key: "approval-off", label: t("organization.dashboard.approval"), value: t("organization.dashboard.approval-off") });
      const s = c.period.summary;
      if (!c.period.months) rows.push({ key: "period-none", label: t("organization.dashboard.period"), value: t("organization.dashboard.period-none") });
      else if (!s) rows.push({ key: "period-idle", label: t("organization.dashboard.period"), value: t("organization.dashboard.period-idle", { months: c.period.months }) });
      else rows.push({ key: "period", label: t("organization.dashboard.period"), value: `${t(`organization.dashboard.period-${s.status === "OPEN" ? "open" : "closed"}`)} · ${s.closed}/${s.total}`, link: `/${product}/entities`, warn: s.status === "OPEN" && s.open > 0 });
      return { product: c.product, title: t(`product.${product}.product`), link: `/${product}/entities`, scoped: !!c.period.scoped, rows };
    });
